import gql from 'graphql-tag';

const UPDATE_ARAMBH_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $flag: Boolean!) {
    markArambhDevice(deviceSerialNo: $deviceSerialNo, flag: $flag) {
      code
    }
  }
`;

export default UPDATE_ARAMBH_DEVICE;
